<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
    @shown="setNotificationsRead"
    @hidden="newNotificationsCount = 0"
  >
    <template #button-content>
      <feather-icon
        :badge="
          notifications && notifications.notifications_count > 0
            ? notifications.notifications_count
            : null
        "
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">الإشعارات</h4>
        <b-badge v-if="newNotificationsCount > 0" pill variant="light-danger">
          {{ newNotificationsCount }} جديد
        </b-badge>
      </div>
    </li>
    <template v-if="allNotifications.length === 0">
      <div class="p-1 text-center">لا توجد إشعارات بعد</div>
    </template>
    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->

      <b-link
        v-for="(notification, index) in allNotifications"
        :key="notification.id"
        :href="isHref(notification.data) ? getUrl(notification.data) : null"
        :to="isHref(notification.data) ? null : getUrl(notification.data)"
      >
        <b-media
          :class="{ 'notification-read-bg': index < newNotificationsCount }"
        >
          <!-- <template #aside>
            <b-avatar size="32" :src="notification.avatar" :text="notification.avatar" :variant="notification.type" />
          </template> -->
          <div class="d-flex w-100 justify-content-between align-items-top">
            <div>
              <p class="media-heading">
                <span class="font-weight-bolder">
                  {{ notification.data.title }}
                </span>
              </p>
              <small class="notification-text">{{
                notification.data.body
              }}</small>
            </div>
            <div>
              <small>
                <time class="text-muted text-body">
                  {{ $moment(notification.created_at).fromNow() }}
                </time>
              </small>
            </div>
          </div>
        </b-media>
      </b-link>

      <!-- System Notification Toggler -->
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <router-link
        :to="
          isMinistry
            ? { name: 'ministry-notifications' }
            : { name: 'user-notifications' }
        "
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          block
        >
          عرض كافة الإشعارات
        </b-button>
      </router-link>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import { mapGetters, mapActions } from "vuex";
import authHelpers from "@/utils/auth-helpers";
export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },

  computed: {
    ...mapGetters("User", ["notifications", "allNotifications"]),
  },
  data() {
    return {
      newNotificationsCount: 0,
      isMinistry: authHelpers.isUserMinistry(),
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    };
  },
  methods: {
    ...mapActions("User", ["readNotifications"]),
    isHref(notification) {
      var name = notification.notificationType.name;
      return (
        name === "decision" ||
        name === "circular" ||
        name === "system" ||
        name === "law" ||
        name === "decree"
      );
    },
    getUrl(notification) {
      var name = notification.notificationType.name;
      var url = notification.notificationType.url;

      if (name === "dynamic") return "#";
      else {
        if (
          name === "decision" ||
          name === "circular" ||
          name === "system" ||
          name === "law" ||
          name === "decree"
        )
          return url + notification.regulation_id;
        else return url;
      }
    },
    setNotificationsRead() {
      this.newNotificationsCount = this.notifications.notifications_count;
      this.readNotifications(this.isMinistry);
    },
  },
};
</script>

<style scoped>
.notification-read-bg {
  background-color: #f6f6f6;
}
</style>
